import { ECustomMappingType } from 'entities/broadcast/model';
import { TSelectorTabItem } from 'shared/ui';

export const mappingTypeOptions: TSelectorTabItem<ECustomMappingType>[] = [
  { caption: 'Все', value: ECustomMappingType.ALL, key: ECustomMappingType.ALL },
  { caption: 'Привязанные', value: ECustomMappingType.LINKED, key: ECustomMappingType.LINKED },
  { caption: 'Не привязанные', value: ECustomMappingType.UNLINKED, key: ECustomMappingType.UNLINKED },
];
